import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {CustomizeHttpUrlGenerator} from "../../../../../../../store/core/url/customizeHttpUrlGenerator";
import {FormDefinitionFieldModel} from "../../../api/entity/formDefinitionField.model";
import {AbstractDataServiceV2} from "../../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {FormDefinitionFieldConverter} from "../../../api/entity/converter/formDefinitionField.converter";

@Injectable()
export class FormDefinitionFieldDataService extends AbstractDataServiceV2<FormDefinitionFieldModel, FormDefinitionFieldConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig, converter: FormDefinitionFieldConverter) {
        super('FormDefinitionField', http, httpUrlGenerator, logger, config, converter);
    }
}
